var AbstractEditView = require("../common/AbstractEditView");
var Utils = require("common/Utils");

function AttributesEditView() {
    AbstractEditView.call(this);

    var self = this;

    var uiHelper = require("./AttributesUIHelper");

    var $confirmButton = $('<a href="#" data-role="button" data-icon="mobile-confirm" data-iconpos="notext" data-inline="true">');

    var $listview = $('<ul data-role="listview" data-inset="false" class="fieldsList">');
    var $form = $('<form action="javascript:void(0);" data-action="">');
    var $content = $('<div id="attributesContent">').append($form.append($listview));

    var currentCategory;

    /**
     * @override
     * @inheritDoc
     */
    this.getHashName = function() {
        return "AttributesEdit";
    };

    function submitChanges() {
        var changes = {};

        if (Utils.isGreaterThanOrEqualToServerVersion(CudaLaunch.serverConfiguration.version, "7.1.0")) {
            changes[currentCategory.namespace] = $form.serializeArray();
        } else {
            changes = $form.serializeArray();
        }

        self.publishEvent("AttributesController", "update-attributes", {changes : changes});
    }

    $confirmButton.on("click", submitChanges);

    function toggleConfirmButton(enabled) {
        Utils.setElementEnabled($confirmButton, enabled);
    }

    /**
     * @override
     * @inheritDoc
     */
    this.getHeaderConfiguration = function() {
        var title;

        if (Utils.isGreaterThanOrEqualToServerVersion(CudaLaunch.serverConfiguration.version, "7.1.0")) {
            title = $.t("common::" + currentCategory.title, {defaultValue : currentCategory.title});
        } else {
            title = currentCategory;
        }
        return {
            title : title,
            rightButtons : [$confirmButton],
            additionalClasses : "close"
        };
    };

    /**
     * @override
     * @inheritDoc
     */
    this.getContent = function() {
        return $content;
    };

    this.setCategory = function(category, attributes) {
        currentCategory = category;
        toggleConfirmButton(false);

        $listview.empty();

        for (var j = 0; j < attributes.length; j++) {
            var $fieldContainer = $("<li>");
            uiHelper.createAttributeUI(attributes[j], $fieldContainer, true, category.namespace);
            $listview.append($fieldContainer);
        }
        $listview.find("input, textarea").on("keyup", function() {
            toggleConfirmButton(true);
        });
        $listview.find("input[type='checkbox'], input[type='number']").on("change", function() {
            toggleConfirmButton(true);
        });

        uiHelper.enhanceAttributesFormItems($listview, submitChanges, true);

        if ($listview.hasClass("ui-listview")) {
            $listview.listview("refresh");
        }
    };
}

Utils.inherits(AttributesEditView, AbstractEditView);

module.exports = AttributesEditView;